import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import PublicationLinks from "../../Publications/components/PublicationLinks";

export const getGuidelinesTableMobile = (items) => {
  const result = (
    <div>
      <Expander showMore="5">
        {items.map((item) => {
          return (
            <dl className="dl-horizontal varsome-dl-horizontal" key={item.key}>
              <span>
                <dt className="col-12 col-xs-12">Guideline</dt>
                <dd className="col-12 col-xs-12">
                  {item.guidelineUrl ? (
                    <a href={getVarsoUrl(item.guidelineUrl)} target="_blank">
                      {item.name || "-"}
                    </a>
                  ) : (
                    item.name || "-"
                  )}
                </dd>
              </span>
              <span>
                <dt className="col-12 col-xs-12">Drugs</dt>
                {item.chemical_relations && item.chemical_relations.length > 0
                  ? item.chemical_relations.map((obj) => {
                      return (
                        <dd key={obj.key} className="col-12 col-xs-12">
                          {obj.chemicalUrl ? (
                            <a
                              href={getVarsoUrl(obj.chemicalUrl)}
                              target="_blank"
                            >
                              {obj.name || "-"}
                            </a>
                          ) : (
                            obj.name || "-"
                          )}
                        </dd>
                      );
                    })
                  : "-"}
              </span>
              <span>
                <dt className="col-12 col-xs-12">Recommended</dt>
                <dd className="col-12 col-xs-12">{item.recommended || "-"}</dd>
              </span>
              <span>
                <dt className="col-12 col-xs-12">Publications</dt>
                <dd className="col-12 col-xs-12">
                  {item.pub_med_references ? (
                    <PublicationLinks
                      limit={10}
                      ids={item.pub_med_references}
                    />
                  ) : (
                    "-"
                  )}
                </dd>
              </span>
              <span>
                <dt className="col-12 col-xs-12">Summary</dt>
                <dd className="col-12 col-xs-12">{item.summary || "-"}</dd>
              </span>
            </dl>
          );
        })}
      </Expander>
    </div>
  );
  return result;
};
